import React, { useState } from "react";
import Buttonc from "../../../../stories/common/button";
import styles from "./index.module.scss";
import { useContactAgent } from "../../../../hooks/react-query/investor/useContactAgent";
import { useToast } from "../../../../stories/common/toast/toast";
import { ContactAgents } from "../../../../stories/investor/amplitude";
import { useParams, useSearchParams } from "react-router-dom";
import useContextHook from "../../../../hooks/context/useContext";
import moment from "moment";

const ContactAgent = ({
  className,
  objPropertyDetails
}: {
  className?: string;
  objPropertyDetails: any;
}) => {
  const [showThankYou, setShowThankYou] = useState(false);
  // const [showNotInterested, setShowNotInterested] = useState(false);
  const { showError }: any = useToast();
  const { propertyId } = useParams();
  const { mobileNumber } = useContextHook();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  const ContactAgentMutation = useContactAgent(
    (data: any) => {
      setShowThankYou(true);
      ContactAgents({
        propertyId: objPropertyDetails?.propertyId,
        propertySFID: objPropertyDetails?.propertySFID,
        shareId: propertyId || "",
        pubPropertySFID: objPropertyDetails?.pubPropertySFID,
        opportunitySFID: objPropertyDetails?.opportunitySFID,
        linkCId: cid,
        linkEmailId: eq,
        ...(mobileNumber && { mobileNumber: mobileNumber })
      });
    },
    (error) => {
      showError("error", error.response.data.message || "something went wrong");
    }
  );
  return (
    <div>
      {showThankYou ? (
        <div className={styles.thankYouBox}>
          <span className={styles.bellIcon}>
            <img src="/images/bell.svg" alt="" />
          </span>
          <span className={styles.thankYouText}>
            Thanks for reaching out! One of our agents will be in touch soon to
            share more details and help you explore this opportunity further.
          </span>
        </div>
      ) : (
        <div className={`${styles.ContactAgent} ${className}`}>
          <div className={styles.heading}>Want to Explore This Investment?</div>
          <div className={styles.description}>
            Submit your interest and one of our agents will follow up to help
            evaluate the deal and answer any questions.
          </div>
          <Buttonc
            type="button"
            label="Connect with an Agent"
            size="large"
            loading={ContactAgentMutation.isPending}
            onClick={() => {
              ContactAgentMutation.mutate({
                pubPropertyId: objPropertyDetails.id,
                date: moment().format("MM-DD-YYYY hh:mm:ss A")
              });
            }}
            className={styles.interestedBtn}
          />
        </div>
      )}
    </div>
  );
};

export default ContactAgent;
